import axios from "axios";
import { SITE_BASE_URL } from "../config/site";

axios.defaults.baseURL = SITE_BASE_URL;

export const eventsRequests = {
  getBloggerData: bloggerName => axios.get(`/api/table/${bloggerName}`),

  getTopSubscribers: bloggerId => axios.get(`/api/subscribers/${bloggerId}`)
};

export const searchRequests = {
  findSubscribers: (bloggerId, subscriberName) =>
    axios.get(
      `/api/subscribers/search/${bloggerId}?subscriber=${subscriberName}`
    ),

  findSubscriberByName: (bloggerId, subscriberName) =>
    axios.get(`/api/subscribers/${bloggerId}/${subscriberName}`)
};

export const historyRequests = {
  getHistoryOfPoints: (bloggerId, subscriberId) =>
    axios.get(`/api/points/${bloggerId}/${subscriberId}`)
};
